module.exports = __webpack_public_path__ + "static/media/logo-rfdme.c36e2c53.png";